import React from 'react';

import {
  resolveOpinionScaleConfig,
  resolveRatingConfig,
  resolveSliderConfig,
} from '../../CustomBlocks/scale/scaleTypes';
import { EditorRoot } from '../slotBookingEditor/SlotBookingEditor.styles';
import { QuizEditorFields } from '../quizBlocksEditor/quizEditor.styles';
import OpinionScaleEditor from './OpinionScaleEditor';
import RatingEditor from './RatingEditor';
import SliderEditor from './SliderEditor';

interface ScaleBlockEditorProps {
  blockKey: string;
  value?: Record<string, any>;
  onChange: (next: Record<string, any>) => void;
}

/** Settings panel for the Rating, Opinion Scale and Slider blocks; each keeps its settings in `blockConfig`. */
const ScaleBlockEditor: React.FC<ScaleBlockEditorProps> = ({ blockKey, value, onChange }) => {
  const renderEditor = () => {
    if (blockKey === 'RatingInput') {
      const config = resolveRatingConfig(value);
      return <RatingEditor config={config} onChange={(patch) => onChange({ ...config, ...patch })} />;
    }
    if (blockKey === 'OpinionScale') {
      const config = resolveOpinionScaleConfig(value);
      return (
        <OpinionScaleEditor config={config} onChange={(patch) => onChange({ ...config, ...patch })} />
      );
    }
    if (blockKey === 'SliderInput') {
      const config = resolveSliderConfig(value);
      return <SliderEditor config={config} onChange={(patch) => onChange({ ...config, ...patch })} />;
    }
    return null;
  };

  return (
    <EditorRoot>
      <QuizEditorFields>{renderEditor()}</QuizEditorFields>
    </EditorRoot>
  );
};

export default ScaleBlockEditor;
